import JsonResponse from "csi/comm/JsonResponse";
import { C8Node } from "src/c8-platform/type/node";
import { cnl } from "src/c8-platform/type/value";
export * from "src/c8-platform/type/node";
export * from "src/c8-platform/type/value";

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export type C8ImageMap = Record<string, cnl>;
export type ParameterMap = Record<string, any>;
export type PathNodeStepCallback = (node: C8Node, nodePrevious: C8Node, attrId: string, isChild: boolean, index?: string | number) => void;
export type PathNodesStepCallback = (nodeStart: C8Node, nodesPrevious: C8Node[], nodes: C8Node[], attrId: string, isChild: boolean, index?: string | number) => C8Node[] | undefined;

export interface RemoveEventHandle {
	remove: VoidFunction;
}

/** common interface for two types of caches (csi/store/Cache and csi/state/Cache) */
export interface ICache {
	add(node: C8Node, timestamp?: number): C8Node;
	cacheNode(node: C8Node): void;
	cacheResponse(response: JsonResponse): void;
	get(url: cnl): C8Node;
	getNodes(urls: cnl[]): C8Node[];

	// 3rd parameter is different between cache implementations, but unused in QueryProcessor where method is needed
	// csi/state/Cache - getPathNode(node: cnl | C8Node, path: string, tm?: number, stepCallback?: PathNodeStepCallback): C8Node;
	// csi/store/Cache - getPathNode(node: cnl | C8Node, path: string, bForce?: boolean, stepCallback?: PathNodeStepCallback): C8Node;
	getPathNode(urlOrNode: cnl | C8Node, path: string, inconsistentBetweenCaches?: any, stepCallback?: PathNodeStepCallback): C8Node;

	getPathNodes(urlOrNode: cnl | C8Node, path: string, tm?: number, stopIfUnresolved?: boolean, stepCallback?: PathNodesStepCallback): C8Node[];
	remove(url: cnl): void;
	setData?(data: C8Node[]): void;
}

export interface IDataStore<T> {
	/** return item at given index */
	get(index: number): T;

	/** return identity of item */
	getIdentity?: (item: T) => string;

	/** return index of item with given identity value */
	getIdentityIndex: (id: string) => number | undefined;

	/** return identity of next (or previous) item in the store relative to item with given identity value */
	getNextIdentity: (id: string, previous?: boolean, defaultToFirst?: boolean) => string | undefined;

	/** load items from start to end (inclusive), returning total number of items in store (even if not loaded yet) */
	load: (start?: number, end?: number) => Promise<number>;

	/** move item from one index to another */
	move: (from: number, to: number) => void;

	/** remove item with given identity from store */
	remove: (id: string) => void;

	/** total number of items in store */
	total: number | undefined;
};

/** interface for access rules */
export interface AccessRule {
	applyToForm?: boolean;
	exp?: string;
	id1?: string;
	id2?: string;
	op?: string;
	path?: string;
	setting?: string;
	value?: string;
}

/** object containing file information */
export interface IFileData {
	/** file extension */
	ext: string;

	/** file object if not yet published */
	file?: File;

	/** unique id for file */
	id: string;

	/** if image, then url for image node */
	imageUrl?: cnl;

	/** file name */
	name: string;

	/** if an image file, then url to thumbnail image */
	thumbnail?: string;

	/** url to download */
	url: string;
}

export interface ISimpleStoreItem {
	/** unique identifier */
	id: string;

	/** displayable name */
	name: string;
}
